import React, { useState } from 'react';
import MarketCard from '../../components/MarketCard/MarketCard';
import { List } from 'antd';
import { MarketData } from '../../MockData/MarketData';
import TimelyLogo from '../../images/background/timelyCart.png';
import ArtLabLogo from '../../images/background/artlabCart.png';
import MailerSendLogo from '../../images/background/mailerSendCart.png';
import TDBLogo from '../../images/background/tdbfileCart.png';
import WorkiLogo from '../../images/background/workiCart.png';
import DiwoAILogo from '../../images/background/diwoAICart.png';

const Market = (props) => {

    const [data] = useState([...MarketData]);
    return (
        <div>
            <div className='pageTitleMarket' style={{ padding: 16, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ fontWeight: 600, fontSize: 24, color: '#3B3B3B' }}>Маркет</div>
                <div style={{ marginTop: 4, fontWeight: 400, fontSize: 14, color: '#3B3B3B' }}>Таны бүтээмжийг нэмэгдүүлэх хэрэгслүүд</div>
            </div>
            <div style={{ margin: 16, display: 'flex' }}>
                <List
                    grid={{
                        gutter: [0, 16]
                    }}
                    dataSource={data}
                    renderItem={(r) => {
                        let tLogo = null;

                        if (r.id == 2) {
                            tLogo = TimelyLogo;
                        }
                        else if (r.id == 3) {
                            tLogo = ArtLabLogo;
                        }
                        else if (r.id == 4) {
                            tLogo = MailerSendLogo;
                        }
                        else if (r.id == 5) {
                            tLogo = TDBLogo;
                        }
                        else if (r.id == 6) {
                            tLogo = WorkiLogo;
                        }else if (r.id == 7) {
                            tLogo = DiwoAILogo;
                        }

                        return (<MarketCard key={r?.id} id={r.id} title={r.title} imageUrl={tLogo} company={r.company} description={r.description} price={r.price} disable={r?.disable} hidepricetype={r?.hidepricetype} />);
                    }}
                />
            </div>
        </div>
    );
}

export default Market;